import React, { useCallback, useEffect, useState } from 'react'; // eslint-disable-line

export default function useDeviceScroll(ref: HTMLElement | Window = window) {
  const [scrollPosition, setScrollPosition] = useState(() => {
    return document.body.scrollTop || document.documentElement.scrollTop;
  });

  const handleScrollChange = useCallback(() => {
    const newScrollPosition = ref['scrollTop'] ?? (document.body.scrollTop || document.documentElement.scrollTop);

    if (scrollPosition !== newScrollPosition) {
      setScrollPosition(newScrollPosition);
    }
  }, [scrollPosition, ref]);

  useEffect(() => {
    handleScrollChange();
    ref.addEventListener('scroll', handleScrollChange, false);

    return () => {
      ref.removeEventListener('scroll', handleScrollChange, false);
    };
  }, [handleScrollChange, ref]);

  return scrollPosition;
}
